import { useEffect, useRef } from 'react';
function usePrevious(value) {
  'use no memo';

  const ref = useRef(value);

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  // React compiler does not like that we're accessing the ref during render
  return ref.current;
}
export default usePrevious;